import React, { useContext } from "react";
import _ from 'lodash'

import { useFilter } from "./Filter";
import {
    FilteredTrademarks,
    countries_filter,
    filterTrademarksByText,
    filterTrademarkByCountry,
    reference_filter,
    filterTrademarksByReference,
    filterTrademarkByStatus,
    free_text_filter,
    owner_filter,
    filterTrademarkByAgent,
} from "./utils";
import { FilterConfig } from "./utils";
import { Trademark, TrademarkFamily, useTrademarks } from "../trademarks/TrademarksProvider";
import { translateforTrademarks } from "./IpStatusFilter";

const FilteredTrademarksContext = React.createContext({
    trademarks: [] as Trademark[],
    trademarkFamilies: [] as TrademarkFamily[],

    trademarkById: {} as Record<number, Trademark>,
    trademarksByFamilyId: {} as Record<number, Trademark[]>,
    trademarkFamilyById: {} as Record<number, TrademarkFamily>,
})

export function FilteredTrademarksProvider({ children }) {
    const { /*showActiveOnly,*/ activeFilters, ipStates } = useFilter()

    const { trademarks, trademarkFamilies, trademarksByFamilyId, agentsLookup, agentsByTrademarkId } = useTrademarks()

    const fullContext = activeFilters
        .filter(({ isActive }) => isActive)
        .reduce(
            (ctxt: FilteredTrademarks, filter: FilterConfig) => {
                switch (filter.name) {
                    case countries_filter:
                        return filterTrademarkByCountry(ctxt, filter.config);
                    case reference_filter:
                        return filterTrademarksByReference(ctxt, filter.config);
                    case free_text_filter:
                        return filterTrademarksByText(ctxt, filter.config);
                    case owner_filter:
                    //case contact_filter:
                        return filterTrademarkByAgent(ctxt, filter.config, filter.name, agentsLookup, agentsByTrademarkId);
                    default:
                        return ctxt;
                }
            },
            { trademarkFamilies, trademarks }
        );

    const context = filterTrademarkByStatus(fullContext, ipStates.map(translateforTrademarks), trademarksByFamilyId)

    const value = {
        ...context,
        trademarkById: _.keyBy(context.trademarks, 'trademarkId'),
        trademarksByFamilyId: _.groupBy(context.trademarks, 'familyId'),
        trademarkFamilyById: _.keyBy(context.trademarkFamilies, 'familyId'),
    }

    return (
        <FilteredTrademarksContext.Provider value={value}>{children}</FilteredTrademarksContext.Provider>
    );
}

export function useFilteredTrademarks() {
    return useContext(FilteredTrademarksContext);
}

export function useAllOrFilteredTrademarks(applyGlobalFilter = true) {
    const allContext = useTrademarks()
    const filteredContext = useFilteredTrademarks()

    return applyGlobalFilter ? filteredContext : allContext
}
